
import { Link, useLocation } from 'react-router-dom';
import { withOktaAuth } from '@okta/okta-react';
import {Offcanvas  } from 'react-bootstrap';

const Sidebar = (props) => {
	
	const handleOnhide =() =>{
		props.onHide()
		
	}	



	return (

		<>
			<Offcanvas show={props.isShow} placement={"end"} onHide={handleOnhide} >
				<Offcanvas.Header closeButton>
					<Offcanvas.Title>Filters</Offcanvas.Title>
				</Offcanvas.Header>
				<Offcanvas.Body>
					{props.children}
				</Offcanvas.Body>
			</Offcanvas>
		</>
	)

}

export default withOktaAuth(Sidebar);